import axios from 'axios'

import { DocumentType } from '../Interfaces/Draft/DraftInterface'
import {
  EmailDocumentType,
  EmailInterface,
  InvoiceDeliveryEmailInterface,
  InvoiceEmailTemplateInterface,
} from '../Interfaces/EmailInterface'
import { getToken } from './apiHelper'
import { getRequestConfig } from './index'

export async function sendEmail(email: InvoiceDeliveryEmailInterface, documentType: DocumentType, documentId: number) {
  const url = `/invd/email/${documentType}/${documentId}`
  const response = await axios.post(url, email, getRequestConfig())
  return response.data
}

export async function getEmailTemplate(
  documentType: EmailDocumentType,
  locale: string,
): Promise<InvoiceEmailTemplateInterface> {
  const url = `/invd/email/template/${documentType}/${locale}`
  const response = await axios.get(url, getRequestConfig())
  return response.data
}

export async function postEmailTemplate(
  documentType: EmailDocumentType,
  locale: string,
  template: Pick<EmailInterface, 'body'>,
) {
  const url = `/invd/email/template/${documentType}/${locale}`
  const response = await axios.post(url, template, getRequestConfig())
  return response.data
}

export function attachmentUploadEndpoint(documentType: DocumentType, documentId: number) {
  return `/invd/attachment/${documentType}/${documentId}?token=${getToken()}`
}

export function attachmentDeleteEndpoint(documentType: DocumentType, documentId: number) {
  return `/invd/attachment/${documentType}/${documentId}`
}

export function attachmentUploadEndpointForSession(sessionId: string) {
  return `/invd/attachment/${sessionId}?token=${getToken()}`
}

export function attachmentDeleteEndpointForSession(sessionId: string) {
  return `/invd/attachment/${sessionId}`
}
